import api from "./api";

async function send_acess(id: string | number, btid: string) {
  try {
    const { data } = await api.get(
      `/users/add-clicks/${id}/${btid}/`
    );
    return data;
  } catch (e) {
    return {};
  }
}

const feedback = { send_acess };

export default feedback;
